import type { QueryClient } from '@tanstack/react-query';
import type { DesfazerResponse, HistoricoRegistroResponse, RecursoDesfazivel } from '@triade/contracts';
import { toast } from 'sonner';
import { ApiError, requisitar } from '@/lib/api';

/**
 * Depois de um salvar: se a ultima alteracao do registro pode ser desfeita (`desfazivel`, decidido pela API), mostra o toast
 * "Alteração salva" com o botao "Desfazer" por 30 s. Nao bloqueia nem quebra o salvar: se a consulta falhar, nao mostra nada.
 */
export async function avisarDesfazer({ recurso, chave, qc }: { recurso: RecursoDesfazivel; chave: string; qc: QueryClient }): Promise<void> {
  let ultimo: HistoricoRegistroResponse['itens'][number] | undefined;
  try {
    const historico = await requisitar<HistoricoRegistroResponse>('/desfazer/registro', { query: { recurso, chave, limite: 1 } });
    ultimo = historico.itens[0];
  } catch {
    return;
  }
  if (!ultimo?.desfazivel) return;
  const id = ultimo.id;

  toast.success('Alteração salva', {
    duration: 30000,
    action: {
      label: 'Desfazer',
      onClick: () => {
        void requisitar<DesfazerResponse>(`/desfazer/${id}`, { method: 'POST' }).then(
          async () => {
            toast.success('Alteração desfeita');
            await qc.invalidateQueries();
          },
          (e: unknown) => toast.error(e instanceof ApiError ? e.message : 'falha de comunicação com a API'),
        );
      },
    },
  });
}
